export default function TrustBar() {
  return (
    <section className="bg-[#f6f7f5] py-12 border-t border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-10 text-center">

        <div>
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-2">
            Purity
          </p>
          <p className="text-lg font-serif">
            100% Natural Spices
          </p>
        </div>

        <div>
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-2">
            Quality
          </p>
          <p className="text-lg font-serif">
            Premium Grading & Sorting
          </p>
        </div>

        <div>
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-2">
            Reliability
          </p>
          <p className="text-lg font-serif">
            On-Time Global Delivery
          </p>
        </div>

        <div>
          <p className="text-sm uppercase tracking-widest text-gray-500 mb-2">
            Value
          </p>
          <p className="text-lg font-serif">
            Competitive Export Prices
          </p>
        </div>

      </div>
    </section>
  );
}
